import React from 'react';
import apruvWordmark from '../../assets/images/apruv-wordmark-v2.svg';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';

interface PoweredByApruvProps {
  compact?: boolean;
  sx?: SxProps<Theme>;
}

const PoweredByApruv: React.FC<PoweredByApruvProps> = ({ compact = false, sx }) => {
  return (
    <Box
      component="a"
      href="https://apruv.io"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Powered by Apruv"
      sx={[
        {
          color: 'var(--cx-brand-text-muted, var(--text-color-secondary, #667085))',
          py: compact ? 0.5 : 1.25,
          textAlign: 'center',
          display: 'block',
          textDecoration: 'none',
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <Typography
        component="p"
        variant="caption"
        sx={{
          color: 'inherit',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: '0.02em',
          lineHeight: 1.4,
        }}
      >
        Powered by{' '}
        <Box component="img" src={apruvWordmark} alt="Apruv" sx={{ width: compact ? 58 : 66, height: compact ? 18 : 20, objectFit: "contain" }} />
      </Typography>
    </Box>
  );
};

export default PoweredByApruv;
